let curl = ''
let login = ''
let curs = ''
let curls = ''
if (location.host == '120.79.92.205') { //正式
	curl = 'http://120.79.92.205:2347/'; //正式
	login = 'http://120.79.92.205:2347/'; //正式
	curls = 'http://120.79.92.205:3785/'; //正式
  curs = 'http://120.79.92.205:3789/'
} else { //測試 localhost
	// curl = 'http://202.130.113.149:2347/'; //测试
	// login = 'http://202.130.113.149:2347/'; //测试
	// curls = 'http://202.130.113.149:3785/'; //测试
  // curs = 'http://202.130.113.149:3789/'

	// curl = 'http://192.168.31.238:2347/'; //本地
	// login = 'http://192.168.31.238:2347/'; //本地
	// curls = 'http://192.168.31.238:3785/'; //本地
  // curs = 'http://192.168.31.238:3789/'

  curl = 'https://www.qmisgroup.com:2347/'; //正式 https://www.qmisgroup.com:2347/
  login = 'https://www.qmisgroup.com:2347/'; //正式 https://www.qmisgroup.com:2347/
  curls = 'https://hk.qmisit.com:3785/'; //正式 https://hk.qmisit.com:2346
  curs = 'https://hk.qmisit.com:3789/'

}
if(location.hostname == 'hk.qmisit.com'||location.hostname == 'www.qmisgroup.com'||
location.hostname == 'qmisgroup.com'){
  curl = 'https://www.qmisgroup.com:2347/'; //正式 https://www.qmisgroup.com:2347/
  login = 'https://www.qmisgroup.com:2347/'; //正式 https://www.qmisgroup.com:2347/
  curls = 'https://hk.qmisit.com:3785/'; //正式 https://hk.qmisit.com:2346
  curs = 'https://hk.qmisit.com:3789/'
}
if(sessionStorage['onlinestate'] == 'pc'){
  curl += 'groupweb/'
}else{
  curl += 'groupwebapp/'
}
curs += 'qmisweb/'

module.exports = {
  getGroupRevelation:curl + 'getGroupRevelation',
  getResponsibleOfficerTypePage:curl+'getResponsibleOfficerTypePage',
  //免責聲明
  getGroupDisclaimer:curl + 'getGroupDisclaimer',
  //德股服務收費
  getDEServiceCostList:curl+'getDEServiceCostList',
  //德股交易方式
  getDETradingWay:curl+'getDETradingWay',
  //德股市場介紹
  getDEMarketInfo:curl+'getDEMarketInfo',
  getResponsibleOfficerType149Page:curl+'getResponsibleOfficerType149Page',
  getResponsibleOfficerType1Page:curl + 'getResponsibleOfficerType1Page',
  getAlldownloads:curl + 'getAlldownloads',
  tocurl:curl,
  //搜索.
  getUrlWithSearchStr:curl+'getUrlWithSearchStr',
  getcurlWithSearchStr:curl+'getcurlWithSearchStr',
  //資產管理
  getIntroductionPage:curl +'getIntroductionPage',
  getHKMarketInfo: curl + 'getHKMarketInfo',
  getUSMarketInfo:curl + 'getUSMarketInfo',
  getWelcomeToJoin:curl + 'getWelcomeToJoin',
  getHkTradingWay:curl + 'getHkTradingWay',
  getHkServiceCost:curl + 'getHkServiceCost',
  getGroupMenu:curl + 'getGroupMenu',
  getUSTradingWay:curl + 'getUSTradingWay',
  getSHKMarketInfo:curl + 'getSHKMarketInfo',
  getSHKTradingWay:curl + 'getSHKTradingWay',
  getSGMarketInfo:curl + 'getSGMarketInfo',
  getSGTradingWay:curl + 'getSGTradingWay',
  getTPMarketInfo:curl + 'getJPMarketInfo',
  getJPTradingWay:curl + 'getJPTradingWay',
  getTWMarketInfo:curl + 'getTWMarketInfo',
  getTWTradingWay:curl + 'getTWTradingWay',
  getAUMarketInfo:curl + 'getAUMarketInfo',
  getMYSMarketInfo:curl + 'getMYSMarketInfo',
  getMYSTradingWay:curl + 'getMYSTradingWay',
  getAUTradingWay:curl  +'getAUTradingWay',
  getHKServiceCostList:curl + 'getHKServiceCostList',
  getUSServiceCostList:curl + 'getUSServiceCostList',
  getSHKServiceCostList:curl + 'getSHKServiceCostList',
  getSGServiceCostList:curl + 'getSGServiceCostList',
  getJPServiceCostList:curl + 'getJPServiceCostList',//日
  getMYSServiceCostList:curl + 'getMYSServiceCostList',
  getAUServiceCostList:curl + 'getAUServiceCostList',
  getTWServiceCostList:curl + 'getTWServiceCostList',
  getAllCostList:curl + 'getAllCostList',
  getStockTransferInfo:curl + 'getStockTransferInfo',
  getBondService:curl + 'getBondService',
  getFundService:curl + 'getFundService',
  getIpoPageInfo:curl + 'getIpoPageInfo',
  AccopenInperson:curl + 'getAccopenInperson',
  getAssetAccopenInperson:curl + 'getAssetAccopenInperson',
  AccopenByPost:curl + 'getAccopenByPost',
  AccopenByAppointment:curl + 'getAccopenByAppointment',
  AccopenOnline:curl + 'getAccopenOnline',
  DataService:curl + 'getDataService',
  TableDownload:curl + 'getTableDownload',
  getAssetTableDownload:curl + 'getAssetTableDownload',
  GroupFAQ:curl + 'getGroupFAQ',
  FAQPage:curl + 'getFAQPage',
  HolidaysPage:curl + 'getHolidaysPage',
  FDAWPage:curl + 'getFDAWPage',
  getAssetFDAWPage:curl + 'getAssetFDAWPage',
  AboutUsPage:curl + 'getAboutUsPage',
  getNoticePage:curl + 'getNoticePage',
  getNoticeWithid:curl + 'getNoticeWithid',
  getFirstPage:curl + 'getFirstPage',
  getContactUsPage:curl + 'getContactUsPage',
  getManagement:curl + 'getManagementServicesPage',
  getInvestment:curl + 'getInvestmentStrategyPage',
  getCFPPage:curl + 'getCFPPage',
  discretionary:curl + 'getDiscretionaryPage',
  advicePage:curl + 'getSafenoticeAdvicePage',
  getTermsAnd:curl + 'getTermsAndConditionsPage',
  getHyperlink:curl + 'getHyperlinkPolicyPage',
  getSecuritiesPage:curl + 'getSecuritiesPage',
  getJoinUsPage:curl + 'getJoinUsPage',
  getHSGTMarketPage:curl + 'getHSGTMarketPage',
  getHSGTTradingWayPage:curl + 'getHSGTTradingWayPage',
  //私隱政策
  getPrivacyPolicyPage:curl + 'getPrivacyPolicyPage',
  //風險披露
  getRiskDisclaimerPage:curl + 'getRiskDisclaimerPage',
   //个人声明
  getInforCollectPage2:curl + 'getInforCollectPage2',
  getThirdWebRevelation:curl + 'getThirdWebRevelation',
  signHkidrFile:curs + 'signHkidrFile',

  yuyuekaihu: curl + 'getOtherPages/yuyuekaihu',
  zaixiankaihu: curl + 'getOtherPages/zaixiankaihu',
  wangshangjiaoyi: curl + 'getOtherPages/wangshangjiaoyi',
  jiaoxueshipin_cn: curl + 'getOtherPages/jiaoxueshipin_cn',
  jiaoxueshipin_en: curl + 'getOtherPages/jiaoxueshipin_en',
  jiaoxueshipin_web: curl + 'getOtherPages/jiaoxueshipin_web',
  getHolidayList: curls + 'kaihu/getHolidayList',
  newWebYuyue2: curls + 'kaihu/newWebYuyue2',
  getFundProducts: curl + 'getFundProducts',
  getFundToWebsite: curls + 'admin/getFundToWebsite',
  submitCustomerFundInfo: curls + 'admin/submitCustomerFundInfo',
  getBondProducts: curl + 'getBondProducts',
  getBondToWebsite: curls + 'admin/getBondToWebsite',
  submitCustomerBondInfo: curls + 'admin/submitCustomerBondInfo',
  addFundQuestionnaire: curls + 'admin/addFundQuestionnaire',
  checkIOQSignStatus: curls + 'admin/checkIOQSignStatus',
  addQuestionnaire: curls + 'admin/addQuestionnaire',
  getLoginUserInfo: curls + 'admin/getLoginUserInfo',
  buyBonds: curls + 'admin/buyBonds',
  buyFunds: curls + 'admin/buyFunds',
  getSwitchStatus: login + 'groupweb/getSwitchStatus',
  
}


// WEBPACK FOOTER //
// ./src/assets/api.js